<!-- Dropdown starts -->
<div >
    <section class="mis_dropdown">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="border">
                        <div class="searchwidth">
                            <div class="input-group">
                                <input type="text" class="form-control misinput_control"
                                    placeholder="Search By Student Name, Admission No., Mobile No." maxlength="9">
                                <div class="input-group-btn">
                                    <button class="btn drop_iconsearch" type="submit">
                                        <i class="fa fa-search" aria-hidden="true">
                                        </i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Dropdown ends -->

    <!-- ========================= Academic Counselling Form ========================= -->
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <!-- desktop table view open-->
                    <div class="ibox">
                        <div class="ibox-title report_flexweb">
                            <div>
                                <h5 class="councel__name"> <i class="fa-solid fa-less-than" (click)="backToAcademic()"></i><span class="home">Back To Home</span>Academic Counselling Form</h5>
                            </div>
                            <div class="icon_flex">
                                <!-- <div>
                                    <a href="#" class="dload_rpt"> <span><img
                                                src="../../../../assets/image/vscode-icons_file-type-excel.svg"
                                                alt=""></span>&nbsp;Export in Excel</a>
                                </div>
                                <div>
                                    <a href="#" class="dload_rpt"> <span><img
                                                src="../../../../assets/image/vscode-icons_file-type-pdf2 (1).svg"
                                                alt=""></span>&nbsp;Export in PDF</a>
                                </div> -->
                            </div>
                        </div>
                        <div class="ibox-content">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped cctv_datatable" id="studenttable">
                                    <thead>
                                        <tr>
                                            <th style="width:110.463px;">Student’s Name</th>
                                            <th style="width: 109.363px;">Admission Number</th>
                                            <th style="width: 52.0625px;">Grade</th>
                                            <th style="width: 79.0875px;">Exam Program</th>
                                            <th style="width: 80.5625px;">Program Name</th>
                                            <th style="width: 29.9125px;">Date</th>
                                            <th style="width: 42px;">Status</th>
                                            <th style="width: 41.35px;">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container>
                                            <tr *ngFor="let stddata of Table_details">
                                                <td style="font-family: montserrat,sans-serif;">{{stddata.studentName}}
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">{{stddata.admNo}}</td>
                                                <td style="font-family: montserrat,sans-serif;">{{stddata.grade}}</td>
                                                <td style="font-family: montserrat,sans-serif;">{{stddata.examProgram}}
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">{{stddata.programName}}
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;"><span
                                                        class="">{{stddata.counselDate}}</span>
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">
                                                    <ng-container *ngIf="stddata.counselStatus=='PENDING'">
                                                        <span class="track_pending"><span></span>Pending</span>
                                                    </ng-container>
                                                    <ng-container *ngIf="stddata.counselStatus=='Submitted'">
                                                        <span class="track_approve"><span></span>submitted</span>
                                                    </ng-container>
                                                </td>
                                                <td><a *ngIf="stddata.counselStatus !='Submitted'" (click)="pending(stddata)"><img
                                                    [attr.disabled]="true" src="../../../../assets/image/edit.svg" alt="edit"></a>
                                                    <a *ngIf="stddata.counselStatus=='Submitted'" (click)="submitted(stddata)" ><img
                                                         src="../../../../assets/image/carbon_view.svg" alt="edit"></a>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>